import { getSentryExtra } from '../../error/getSentryExtra';
import Logger from '../../lib/Logger';
import { generateRecaptchaToken as generateRecaptchaTokenFromLib } from '../../store/google-recaptcha/action-creators';
const LOG = Logger.getLogger('generateRecaptchaToken');
export const generateRecaptchaToken = action => dispatch => dispatch(generateRecaptchaTokenFromLib(action)).catch(errorMessage => {
  LOG.error('Error generating recaptcha token', {
    extra: getSentryExtra(errorMessage)
  });
});